import { render, staticRenderFns } from "./password-recovery.vue?vue&type=template&id=c3457376"
import script from "./password-recovery.vue?vue&type=script&lang=js"
export * from "./password-recovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports